export default "__VITE_ASSET__DaPLhnKp__"